<template>
  <div>
    <BaseElSwitch
      v-model="syncValue.enable"
      :active-text="'開啟'"
      :inactive-text="'關閉'"
    />

    <template v-if="showControl.detail">
      <BaseElFormItem label="顯示文字" :prop="`${propKey}.label`">
        <BaseElInput
          v-model="syncValue.label"
          :maxlength="6"
          show-word-limit
        />
      </BaseElFormItem>
      <BaseElFormItem label="連結" :prop="`${propKey}.link`">
        <BaseElInput
          v-model="syncValue.link"
          placeholder="https://"
        />
      </BaseElFormItem>
    </template>
  </div>
</template>

<script>
import { useVModel } from '@vueuse/core'
import { computed, defineComponent } from 'vue'
export default defineComponent({
  name: 'EditAppointmentNoteBtnSetting',
  props: {
    propKey: String,
    value: {
      type: Object,
      default: () => ({
        enable: false,
        label: undefined,
        link: undefined,
      }),
    },
  },
  setup (props, { emit }) {
    const syncValue = useVModel(props, 'value', emit)

    const showControl = computed(() => {
      const controls = {
        detail: syncValue.value.enable,
      }

      return controls
    })

    return {
      syncValue,
      showControl,
    }
  },
})
</script>

<style lang="postcss" scoped>

</style>
